<template>
  <div class="productsSection container">
    <SectionContainer :title="data.title">
      <div class="productsSection__content">
        <SliderTiles
          slides-per-view="auto"
          content-type="product"
          :items="items"
          nav-buttons-type="rounded"
        />
      </div>
    </SectionContainer>
  </div>
</template>

<script>
import CategoriesWithListGrid from '@/components/CategoriesWithListGrid.vue';
import SectionContainer from '@/components/SectionContainer.vue';
import SliderTiles from '@/components/Sliders/SliderTiles.vue';

export default {
  name: 'ProductsSection',
  components: { SliderTiles, SectionContainer, CategoriesWithListGrid },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped lang="scss">
.productsSection {
  &__content {
    padding: 2rem 0 2rem;
  }
}
</style>
